import { getMaps } from 'Plugins/FloorPlan/Utils/Room/MapByType';
import React from 'react';

import { Logger } from '../../../../Errors/Logger';
import { LogLevelType } from '../../../../Services/Analytics/LogLevelType';
import { PlanGroup, SvgContainer } from './ExportMapByTypeSvg';
import { calculateMapBox, ExportMapSvgProps } from './ExportMapSvg';
import { ExportMapImageHelper } from './Helpers/ExportMapPngHelper';
import { SvgHelpers } from './Helpers/SvgGenerationHelpers';

const ExportMapPlanSvgId = 'ExportMapPlanSvg';

export const useExportMapPlanSvg = ({ style, mapState }: ExportMapSvgProps) => {
    const svgPlanWrapper = React.useRef<SVGSVGElement>(null);
    const capturePlanSvg = () => {
        return SvgHelpers.capture(svgPlanWrapper.current?.outerHTML, true);
    };
    const capturePlanPng = () => {
        const svgImage = capturePlanSvg();
        if (!svgImage) {
            Logger.logAnalytics({
                message: 'capturePlanSvg',
                level: LogLevelType.Warning,
                type: 'NULL_SVG_IMAGE',
                data: {
                    document: document.getElementById(ExportMapPlanSvgId)?.outerHTML || '-',
                    roomLength: mapState.rooms?.length || 0,
                },
            });
            return Promise.resolve('');
        }
        return ExportMapImageHelper.exportMapPng(svgImage);
    };

    const { sol, wall } = getMaps(mapState);
    const solBBox = calculateMapBox(sol);
    const wallBBox = calculateMapBox(wall);

    const width = Math.max(solBBox?.width || 0, wallBBox?.width || 0);
    const height = (solBBox?.height || 0) + (wallBBox?.height || 0);
    const xMin = (solBBox?.xMin ?? wallBBox?.xMin) || 0;
    const yMin = (solBBox?.yMin ?? wallBBox?.yMin) || 0;
    const xDiff = solBBox ? (wallBBox?.xMin || 0) - (solBBox?.xMin || 0) : 0;
    const translateWallstyle = { transform: `translate(${xDiff > 0 ? -xDiff : -xDiff}px, ${solBBox?.height || 0}px)` };

    return {
        capturePlanSvg,
        capturePlanPng,
        mapPlanView: () => (
            <SvgContainer
                id={ExportMapPlanSvgId}
                ref={svgPlanWrapper}
                xmlns="http://www.w3.org/2000/svg" //!\ IMPORTANT FOR EXPORT
                viewBox={`${xMin} ${yMin} ${width} ${height}`}
                width={width}
                height={height}
                style={style}>
                <PlanGroup {...sol} legendPosition={solBBox?.legendPosition} />
                <PlanGroup {...wall} style={translateWallstyle} legendPosition={wallBBox?.legendPosition} />
            </SvgContainer>
        ),
    };
};
